import { Box, Grid, Icon, Image, Text, type ImageProps, type TextProps } from '@chakra-ui/react'
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import type { ReactNode } from 'react'

interface AuthPageLayoutProps {
  title?: ReactNode
  titleIcon?: FontAwesomeIconProps['icon']
  subtitle?: ReactNode
  subtitleProps?: TextProps
  children: React.ReactNode
  logo?: string
  logoProps?: ImageProps
}

export const AuthPageLayout = ({ children, title, titleIcon, subtitle, subtitleProps, logo, logoProps }: AuthPageLayoutProps) => {
  return <Grid
    sx={{
      w: 'full',
      minH: '100vh',
      placeContent: { base: 'start', lg: 'center' },
      placeItems: 'center',
      gridTemplateColumns: { base: '1fr', lg: '1fr 1fr', '2xl': '2fr 3fr' },
      bg: 'white',
      overflow: 'hidden',
    }}
  >
    <Box w="full" h={{ base: 'auto', lg: '100%' }} bg='login-bg' p={{ base: 4, lg: 6 }}>
      <Grid w="full" h={{ base: 'auto', lg: 'calc(100vh - 3rem)' }} gridTemplateRows={{ base: '1fr', lg: '25vh auto auto 3fr' }}>
        <Box />
        {titleIcon && <Icon as={FontAwesomeIcon} icon={titleIcon} boxSize={{ base: 12, lg: 16, xl: 20 }} pt={2} pb={{base: 4, lg: 8, xl: 12}} color="white" mx="auto" />}
        {title && <Text color="white"
          fontSize={{ base: '2xl', lg: '4xl', xl: '5xl' }}
          fontWeight="semibold"
          textAlign="center"
          lineHeight={1.5}
          pt={2}
          pb={{ base: 3, lg: 28 }}
        >
          {title}
        </Text>}
        <Text color="white"
          fontSize={{ base: 'xl', lg: '2xl', xl: '4xl' }}
          fontWeight={{ base: 'normal', lg: 'medium' }}
          textAlign="center"
          lineHeight={1.5}
          {...subtitleProps}
        >
          {subtitle}
        </Text>
        <Box />
      </Grid>
    </Box>
    <Grid w="full" minH={{ base: 'auto', lg: '100vh' }} gridTemplateRows={{ base: '1fr', lg: '25vh auto auto 3fr' }} gridTemplateColumns="1fr" p={{ base: 4, lg: 6 }}>
      <Box />
      {logo && (
        <Box sx={{
          pt: { base: 8, lg: 0 },
          pb: { base: '5vh', md: 12, lg: 20 },
          px: { base: 16, lg: 12 },
          justifySelf: 'center',
          w: 'full',
          maxW: 'xs',
        }}>
          <Image
            src={logo}
            alt=""
            {...logoProps}
            sx={{
              w: 'full',
              maxW: 'xs',
              h: 'full',
              ...logoProps?.sx
            }}
          />
        </Box>
      )}
      {children}
      <Box />
    </Grid>
  </Grid>
}